

export const NAVIGATION_ITEMS = [
  {
    id: 'dashboard',
    path: '/dashboard',
    title: "Dashboard"
  },
  {
    id: 'reminders',
    path: '/reminders',
    title: "Reminders"
  },
  {
    id: 'workers',
    path: '/workers',
    title: "Workers"
  },
  {
    id: 'todos',
    path: '/todos',
    title: "Todos"
  }
];

export const PROFILE_ITEMS = [
  {
    id: 'profile',
    path: '/profile',
    title: 'Your profile'
  },
  {
    id: 'settings',
    path: '/settings',
    title: 'Settings'
  },
  {
    id: 'signout',
    path: '/logout',
    title: 'Sign out'
  }
];

export const SETTINGS_NAVIGATION_IDS = {
  GENERAL: 'general',
  NOTIFICATIONS: 'notifications',
};

export const SETTINGS_ITEMS = [
  {
    id: SETTINGS_NAVIGATION_IDS.GENERAL,
    title: 'General',
    path: '/settings'
  },
  {
    id: SETTINGS_NAVIGATION_IDS.NOTIFICATIONS,
    title: 'Notifications',
    path: '/settings/notifications'
  },
];
